// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

mat-icon {
  font-size: -webkit-xxx-large;
  margin-left: 10px;
}

.request-card {
  background-color: white;
  box-shadow: rgba(103, 103, 103, 0.35) -4px 0px 20px 2px, rgba(255, 255, 255, 0.4) -20px -1px 60px -30px;
  padding: 15px;
  border-radius: 20px;
  margin: 20px;
}
.request-card .right-side {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-left: 20px;
  direction: rtl;
  text-align: right;
}
.request-card .right-side div {
  align-items: baseline;
  display: inline-flex;
}
.request-card .right-side div * {
  margin-right: 5px;
}
.request-card .left-side {
  flex: 1 1 100%;
  box-sizing: border-box;
  max-width: 25%;
  justify-content: center;
  display: flex;
  border-right: 4px dashed #eee;
}
.request-card .left-side div {
  display: inline-flex;
}
.request-card .left-side div * {
  margin-right: 5px;
}

.item {
  padding: 0 10px;
  margin-top: 17px;
  min-width: 230px;
  align-items: center;
  justify-content: center;
}

p {
  margin-top: 5%;
}

.btn_accept {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 150px;
  border: 2px solid #eee;
  background-color: #2a8954;
  color: white;
}

.btn_reject {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 150px;
  border: 2px solid #eee;
  background-color: #d92727;
  color: white;
}

.btn_back {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 150px;
}

.text-item {
  font-size: 12px;
}

.icon-card {
  margin: auto;
  margin-top: 1px;
  margin-left: 8px;
  font-size: 20px;
}

.images {
  margin-top: 35px;
  padding: 10px;
}

.item-image {
  display: grid !important;
}

.label-img {
  margin: auto !important;
  margin-bottom: 10px !important;
}

.btns {
  margin-right: 35rem;
}

label {
  font-size: 12px;
  color: blue;
}

::ng-deep .mat-drawer-content.mat-drawer-content.main-panel {
  background-color: white;
}

.title {
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

mat-icon {
  font-size: 26px;
  margin-left: 10px;
}

button.btn {
  margin-top: 20px;
  margin-right: auto;
}

h1 {
  font-size: 1.5rem;
}

img {
  max-width: 15rem;
  max-height: 15rem;
  width: 100%;
  height: 100%;
  aspect-ratio: 1/1;
  margin-right: 1rem;
  margin-left: 1rem;
}

.parent-both {
  display: flex;
  margin: auto;
  padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/request-rial/request-rial-detail/request-rial-detail.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/request-rial/request-rial-detail/request-rial-detail.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ACCJ;;ADCE;EACE,4BAAA;EACE,iBAAA;ACEN;;ADCE;EACE,uBAAA;EACA,uGAAA;EAEA,aAAA;EACA,mBAAA;EACA,YAAA;ACCJ;ADAI;EASE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;ACNN;ADRM;EACE,qBAAA;EACA,oBAAA;ACUR;ADRQ;EACE,iBAAA;ACUV;ADCI;EACE,cAAA;EACA,sBAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,6BAAA;ACCN;ADAM;EACE,oBAAA;ACER;ADAQ;EACE,iBAAA;ACEV;;ADGE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;ACAJ;;ADGE;EACE,cAAA;ACAJ;;ADEE;EACE,mBAAA;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;ACCN;;ADCE;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;ACEJ;;ADAE;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;ACGJ;;ADDE;EACE,eAAA;ACIJ;;ADFE;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACKJ;;ADHE;EACE,gBAAA;EACA,aAAA;ACMJ;;ADJE;EACE,wBAAA;ACOJ;;ADLE;EACE,uBAAA;EACA,8BAAA;ACQJ;;ADNE;EACE,mBAAA;ACSJ;;ADPE;EACI,eAAA;EACA,WAAA;ACUN;;ADRG;EACG,uBAAA;ACWN;;ADRE;EACE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ACWJ;;ADTE;EACE,eAAA;EACE,iBAAA;ACYN;;ADVE;EACE,gBAAA;EACA,kBAAA;ACaJ;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;ACcF;;ADZA;EACE,aAAA;EACA,YAAA;EACA,aAAA;ACeF","sourcesContent":[".title{\r\n    margin-bottom: 10px;\r\n    margin-top: 10px;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  mat-icon{\r\n    font-size: -webkit-xxx-large;  \r\n      margin-left: 10px;\r\n  }\r\n\r\n  .request-card {\r\n    background-color: white;\r\n    box-shadow: rgb(103 103 103 / 35%) -4px 0px 20px 2px,\r\n      rgb(255 255 255 / 40%) -20px -1px 60px -30px;\r\n    padding: 15px;\r\n    border-radius: 20px;\r\n    margin: 20px;\r\n    .right-side {\r\n      div {\r\n        align-items: baseline;\r\n        display: inline-flex;\r\n     \r\n        * {\r\n          margin-right: 5px;\r\n        }\r\n      }\r\n      display: flex;\r\n      flex-direction: row;\r\n      flex-wrap: wrap;\r\n      justify-content: space-between;\r\n      padding-left: 20px;\r\n      direction: rtl;\r\n      text-align: right;\r\n    }\r\n    .left-side {\r\n      flex: 1 1 100%;\r\n      box-sizing: border-box;\r\n      max-width: 25%;\r\n      justify-content: center;\r\n      display: flex;\r\n      border-right: 4px dashed #eee;\r\n      div {\r\n        display: inline-flex;\r\n     \r\n        * {\r\n          margin-right: 5px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .item {\r\n    padding: 0 10px;\r\n    margin-top: 17px;\r\n    min-width: 230px;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  p {\r\n    margin-top: 5%;\r\n  }\r\n  .btn_accept {\r\n    border-radius: 15px;\r\n      height: 45px;\r\n      font-size: 12px;\r\n      width: 150px;\r\n      border: 2px solid #eee;\r\n      background-color: #2a8954;\r\n      color: white;\r\n  }\r\n  .btn_reject{\r\n    border-radius: 15px;\r\n    height: 45px;\r\n    font-size: 12px;\r\n    width: 150px;\r\n    border: 2px solid #eee;\r\n    background-color: #d92727;\r\n    color: white;\r\n  }\r\n  .btn_back{\r\n    border-radius: 15px;\r\n    height: 45px;\r\n    font-size: 12px;\r\n    width: 150px;\r\n  }\r\n  .text-item{\r\n    font-size: 12px;\r\n  }\r\n  .icon-card {\r\n    margin: auto;\r\n    margin-top: 1px;\r\n    margin-left: 8px;\r\n    font-size: 20px;\r\n  }\r\n  .images{\r\n    margin-top: 35px;\r\n    padding: 10px;\r\n  }\r\n  .item-image{\r\n    display: grid !important;\r\n  }\r\n  .label-img{\r\n    margin: auto !important; \r\n    margin-bottom: 10px !important;\r\n  }\r\n  .btns {\r\n    margin-right: 35rem;\r\n}\r\n  label{\r\n      font-size: 12px;\r\n      color: blue;\r\n  }\r\n   ::ng-deep .mat-drawer-content.mat-drawer-content.main-panel {\r\n      background-color: white;\r\n  }\r\n\r\n  .title{\r\n    margin-bottom: 10px;\r\n    margin-top: 10px;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  mat-icon{\r\n    font-size: 26px;  \r\n      margin-left: 10px;\r\n  }\r\n  button.btn {\r\n    margin-top: 20px;\r\n    margin-right: auto;\r\n}\r\n\r\nh1{\r\n  font-size: 1.5rem;\r\n}\r\nimg{\r\n  max-width: 15rem;\r\n  max-height: 15rem;\r\n  width: 100%;\r\n  height: 100%;\r\n  aspect-ratio: 1/1;\r\n  margin-right: 1rem;\r\n  margin-left: 1rem;\r\n}\r\n.parent-both{\r\n  display: flex;\r\n  margin: auto;\r\n  padding: 20px;\r\n}",".title {\n  margin-bottom: 10px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n}\n\nmat-icon {\n  font-size: -webkit-xxx-large;\n  margin-left: 10px;\n}\n\n.request-card {\n  background-color: white;\n  box-shadow: rgba(103, 103, 103, 0.35) -4px 0px 20px 2px, rgba(255, 255, 255, 0.4) -20px -1px 60px -30px;\n  padding: 15px;\n  border-radius: 20px;\n  margin: 20px;\n}\n.request-card .right-side {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-left: 20px;\n  direction: rtl;\n  text-align: right;\n}\n.request-card .right-side div {\n  align-items: baseline;\n  display: inline-flex;\n}\n.request-card .right-side div * {\n  margin-right: 5px;\n}\n.request-card .left-side {\n  flex: 1 1 100%;\n  box-sizing: border-box;\n  max-width: 25%;\n  justify-content: center;\n  display: flex;\n  border-right: 4px dashed #eee;\n}\n.request-card .left-side div {\n  display: inline-flex;\n}\n.request-card .left-side div * {\n  margin-right: 5px;\n}\n\n.item {\n  padding: 0 10px;\n  margin-top: 17px;\n  min-width: 230px;\n  align-items: center;\n  justify-content: center;\n}\n\np {\n  margin-top: 5%;\n}\n\n.btn_accept {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 150px;\n  border: 2px solid #eee;\n  background-color: #2a8954;\n  color: white;\n}\n\n.btn_reject {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 150px;\n  border: 2px solid #eee;\n  background-color: #d92727;\n  color: white;\n}\n\n.btn_back {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 150px;\n}\n\n.text-item {\n  font-size: 12px;\n}\n\n.icon-card {\n  margin: auto;\n  margin-top: 1px;\n  margin-left: 8px;\n  font-size: 20px;\n}\n\n.images {\n  margin-top: 35px;\n  padding: 10px;\n}\n\n.item-image {\n  display: grid !important;\n}\n\n.label-img {\n  margin: auto !important;\n  margin-bottom: 10px !important;\n}\n\n.btns {\n  margin-right: 35rem;\n}\n\nlabel {\n  font-size: 12px;\n  color: blue;\n}\n\n::ng-deep .mat-drawer-content.mat-drawer-content.main-panel {\n  background-color: white;\n}\n\n.title {\n  margin-bottom: 10px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n}\n\nmat-icon {\n  font-size: 26px;\n  margin-left: 10px;\n}\n\nbutton.btn {\n  margin-top: 20px;\n  margin-right: auto;\n}\n\nh1 {\n  font-size: 1.5rem;\n}\n\nimg {\n  max-width: 15rem;\n  max-height: 15rem;\n  width: 100%;\n  height: 100%;\n  aspect-ratio: 1/1;\n  margin-right: 1rem;\n  margin-left: 1rem;\n}\n\n.parent-both {\n  display: flex;\n  margin: auto;\n  padding: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
